import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function CarLabelsSkeleton() {
    return (
        <Stack gap={1} direction="row" alignItems="center" sx={{ flexGrow: 1 }}>
            <Skeleton variant="rectangular" sx={{ borderRadius: 1, height: 24, width: 100 }} />
            <Skeleton variant="rectangular" sx={{ borderRadius: 1, height: 24, width: 65 }} />
        </Stack>
    );
}
